import React from 'react';
import {Platform} from 'react-native';
import {useTheme, CheckBoxProps, CheckBox} from 'react-native-elements'; // rne-netzon replaced

interface RNECheckBoxProps extends CheckBoxProps {}

const textStyle = {
  fontSize: Platform.OS === 'web' ? 14 : 12,
  fontFamily: 'Quicksand-Regular',
  fontWeight: '400',
};

const containerStyle = {
  backgroundColor: 'transparent',
  borderColor: 'transparent',
  justifyContent: 'center',
};

const activeOpacity = 0.8;

export const RNECheckBox = (props: RNECheckBoxProps) => {
  const {...others} = props;

  return (
    <CheckBox
      {...others}
      textStyle={Object.assign(textStyle,others.textStyle ?? {} )}
      containerStyle={Object.assign(
        others.containerStyle ?? {},
        containerStyle,
      )}
      activeOpacity={activeOpacity}
    />
  );
};
